












import { Component, Vue } from 'vue-property-decorator'
import store from '@/store'
import { getFirstUsageBanner, setFirstUsageBanner } from '@/store/notifications/reducer'
import { pushAnalyticsEvent } from '../../../services/utils'
import { EventDetail } from '@/config/interface'

@Component({
  name: 'first-time-usage-banner',
})
export default class FirstTimeUsageBannerComponent extends Vue {
  show = false
  unsubscribe: any | null = null

  mounted(): void {
    getFirstUsageBanner()
    this.unsubscribe = store.subscribe(
      () => (this.show = !store.getState().notifications.attrs.warningScheduleRemovalDismissed),
    )
  }

  dismiss = (): void => {
    const event: EventDetail = {
      category: 'feature',
      action: 'header.notifications_&_messages',
      label: 'dismiss_alert',
    }
    pushAnalyticsEvent(event)
    setFirstUsageBanner({ warningScheduleRemovalDismissed: true })
  }

  beforeDestroy(): void {
    this.unsubscribe()
  }
}
